"use strict";

var _taggedTemplateLiteral = require("/app/node_modules/@babel/runtime/helpers/taggedTemplateLiteral");

var _templateObject;

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.userFragment = void 0;

var graphql_tag_1 = __importDefault(require("graphql-tag"));

var checkout_1 = require("./checkout");

exports.userFragment = graphql_tag_1.default(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  ", "\n  fragment User on User {\n    id\n    email\n    firstName\n    lastName\n    isStaff\n    defaultShippingAddress {\n      ...Address\n    }\n    defaultBillingAddress {\n      ...Address\n    }\n    addresses {\n      ...Address\n    }\n  }\n"])), checkout_1.checkoutAddressFragment);